<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">
				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
                        <div class="row">
                            <div class="col-md-4">
                                <h2 class="text-white pb-2 fw-bold">Panel Harga Pangan</h2>
                                <!-- <h5 class="text-white op-7 mb-2">Jumlah Penduduk : 310988 / Konsumsi Kg/Kap/Th : 98.6 </h5> -->
                            </div>
                            <div class="col-md-4">

                                        <autocomplete
                                            :url="URL+ 'api/v1/statistik_ketapang_master_kecamatan/autocomplete'"
                                            :customHeaders="{authorization: 'kikensbatara '+token }"
                                            anchor="nama_kecamatan"
                                            :initValue="''"
                                            :placeholder="'Cari Kecamatan'"
                                            :classes="{ input: 'form-control'}"
                                            label="writer"
                                            :onShouldRenderChild="renderChild"
                                            :on-select="getAuto">
                                        </autocomplete> <br>
                                        <br>

                                <br>
                            </div>
                            <div class="col-md-4">
                                
                                    <div class="input-group">
										<!-- <select @change="getTahun()" class="form-control" v-model="form.thn">
                                            <option v-for="data in list_thn" :key="data.id" :value="data.id">{{data.tahun}}</option>
                                        </select> -->
                                        <input @change="cari_data()" v-model="form.date" type="date" class="form-control">
										<div class="input-group-append">
                                            <button @click="Chk_Add()" class="btn btn-info" title="Edit Data" data-toggle="modal" data-target="#m_add_data" :disabled="cek_Add"><i class="fas fa-plus"></i></button>
										</div>
									</div>
                                <br>
                            </div>
                          
                        </div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">
                        <table class="table-kiken table table-head-bg-info" width="100%" >
							<thead>

								<tr class="bg-primary">
                                    <th scope="col" style="width: 5%">No</th>
                                    <th scope="col" style="width: 35%">Uraian</th>
                                    <th scope="col" style="width: 10%">Satuan</th>
                                    <th scope="col" style="width: 5%">Harga</th>
                                    <th scope="col" style="width: 35%">Keterangan</th>
                                    <th scope="col" style="width: 10%"></th>
								</tr>
							</thead>
							<tbody>
								<tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                                <!-- <tr class="h_isitable" > -->
									<td class="text-center">{{index+1}}</td>
									<td >{{data.uraian}}</td>
                                    <td class="text-center">{{data.satuan}}</td>
                                    <td class="text-center">{{data.value}}</td>
                                    <td class="">{{data.keterangan}}</td>
                                    <td class="text-center">
                                        <!-- <button v-if="Chk_Add(data)" @click="selectDataAdd(data)" class="btn btn-info btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button> -->
                                        <!-- &nbsp; -->
                                        <button :disabled="!cek_Add" @click="selectData(data)" class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-pencil-alt"></i></button>
                                    </td>
								</tr>

							</tbody>
						</table>

                       
					</div>
				</div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">
                                        <div class="row" v-if="!Chk_Add()">
                                            <!-- <div class="col-md-6" v-for="data in list_master_harga_id" :key="data.master_panel_harga_id" >
                                                <span class="huruf_input">{{data.uraian}}</span>
                                                <input type="text" class="form-control" v-model="data.value"> <br>
                                            </div>

                                            <div class="col-md-12">
                                                <span class="huruf_input">Keterangan</span>
                                                <textarea v-model="form.keterangan" class="form-control form-control-sm"></textarea>
                                                <br>
                                            </div> -->

                                            <table class="table-kiken table table-head-bg-info" width="100%" >
                                                <thead>

                                                    <tr class="bg-primary">
                                                        <th scope="col" style="width: 40%">No</th>
                                                        <th scope="col" style="width: 20%">Uraian</th>
                                                        <th scope="col" style="width: 40%">Keterangan</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <!-- <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id"> -->
                                                    <tr class="h_isitable"  v-for="data in list_master_harga_id" :key="data.id" >
                                                        <td class="">{{data.uraian}}</td>
                                                        <td >
                                                            <input  type="number"  step="0.01" class="form-control form-control-sm" v-model="data.value">
                                                        </td>
                                                        <td class="text-center">
                                                            <textarea v-model="data.keterangan" class="form-control form-control-sm"></textarea>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        
                                        </div>
                                        <div class="text-center"  v-if="Chk_Add()">
                                            <h4><b>MOHON PILIH KECAMATAN TERLEBIH DAHULU</b></h4>
                                        </div>
                                        <div v-if="data_load" class="text-center">
                                              <div class="loaderku"></div>
                                                <!-- <h5>LOADING ...</h5> -->
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button v-if="!Chk_Add()" type="submit" class="btn bgcol-info btn-md">Simpan</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">ATUR DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div>
                                            <span class="huruf_input">Harga</span>
                                            <input type="text" class="form-control" v-model="form.value"> <br>

                                            <span class="huruf_input">Keterangan</span>
                                            <textarea class="form-control" v-model="form.keterangan"></textarea>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-warning btn-md">Edit</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/statistik_ketapang_panel_harga_pangan/";
const ADD_URL_PANEL_HARGA = URL_APP + "api/v1/statistik_ketapang_master_panel_harga/";
const ADD_URL_DATE = URL_APP + "api/v1/statistik_ketapang_master_thn_bln/";
const FILE_LOAD = URL_APP + "uploads/";
const URL_SERVER = URL_APP;

import Autocomplete from 'vue2-autocomplete-js';

export default {
    components: { Autocomplete },
    data() {
        return {
            data_load : false,
            form : {
                id : '',
                kecamatan_id : '',
                master_panel_harga_id : '',
                value : 0,
                thn : '',
                bln : '',
                tgl : '',
                keterangan : '-',
                date : '',
            },
            id :'',
            cek_load_data : true,
            cek_edit : false,
            cek_tambah : false,
            cek_Add : false,
            cek_disabled : false,
            file_old: "",
            file_path: FILE_LOAD,

            list_data: [],
            list_thn: [],
            list_bln: [],
            list_master_harga_id: [],

            page_first: 1,
            page_last: 0,
            cari_value: "",

            URL : URL_SERVER,
            token : localStorage.token,
        }
    },
    methods: {
        getView: function() {
            this.data_load = true;
            var data1 = this.form.date;
            var data = data1.split('-');

            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    thn : parseInt(data[0]),
                    bln : parseInt(data[1]),
                    tgl : parseInt(data[2]),
                    kecamatan_id : this.form.kecamatan_id
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                    this.list_data = res_data;
                    this.cek_load_data = false;
                    this.data_load = false;

                    if (res_data[0].keterangan == null) {
                        this.cek_Add = false ;
                    } else {
                        this.cek_Add = true;
                    }

            });
        },

        addData: function() {
                this.data_load = true;
                var data1 = this.form.date;
                var data = data1.split('-')

                // console.log(data[1])
                fetch(ADD_URL + "addData", {
                    method: "POST",
                    headers: {
                        'content-type' : 'application/json',
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        thn : data[0],
                        bln : data[1],
                        tgl : data[2],
                        form : this.list_master_harga_id,
                        keterangan : this.form.keterangan,
                        kecamatan_id : this.form.kecamatan_id
                        
                    })
                }).then(res_data => {
                    this.alertku("success", "sukses menambah data");
                    this.getView();
                    this.data_load = false;
                });
           
            
        },

        editData: function() {

            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        selectData: function(data) {
 
                this.form.id = data.id;
                this.form.value = data.value;
                this.form.keterangan = data.keterangan;
                this.form.kecamatan_id = data.kecamatan_id;
  

            console.log(data)
            this.cek_edit = true;
            this.cek_tambah = true;
        },

        selectDataAdd: function(data) {

            this.cek_edit = true;
            this.cek_tambah = true;
        },

        emptyData : function(){
            this.cek_edit = false;
            this.cek_tambah = false;
        },

        Chk_Add : function(data){
            if (this.form.kecamatan_id == null || this.form.kecamatan_id == undefined || this.form.kecamatan_id == '') {
                // console.log('kosong')
                return true;
            } 
            else {
                return false;
            }
           
        },

        removeData: function(idnya) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                    body: JSON.stringify({
                    id: idnya,
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },
        ke_alamat : function(data){
            window.open(data);
        },

    // ================== TAMBAHAN ====================

        getPanelHarga : function(){
            fetch(ADD_URL_PANEL_HARGA, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {
                this.list_master_harga_id = res_data;
                this.form.master_panel_harga_id = res_data[0].id;
                this.getTahun();
            });
        },
        pembulatan : function(a, b){
            var data = a * b/100;
            var hasil = data.toFixed(2);
            return hasil;
        },
        pembulatanX : function(a, b){
            var data = a * b/100;
            return data;
        },
        getDate : function(){
            console.log(this.form.thn)
        },
    // ================== TAMBAHAN ====================

    // ================== AUTOCOMPLETE ====================
        renderChild(data) {
            return `
            <span><b>${data.nama_kecamatan}</b></span>
            <span style='font-size:80%'>${data.nama_kabupaten}</span>
            `
        },
        getAuto : function(obj){
            this.form.kecamatan_id = obj.kecamatan_id;
            this.getView();
            console.log(this.form.kecamatan_id);
        },
    // ================== AUTOCOMPLETE ====================


    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        }
    // ================== PAGINASI ====================
        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;


        this.getPanelHarga();
        

        

        var d = new Date();
        // console.log(d.getMonth())
        this.form.thn = d.getFullYear();
        this.form.bln = d.getMonth();
        this.form.date = d.getFullYear()+"-"+d.getMonth()+"-"+d.getDate()
        this.getView();
    },

}
</script>